// [목적] 단일 폴리오 조회 hook — useQuery + zod 파싱 + queryKey 일원화
// [이유] FolioPage / FolioEditPage 가 동일 키로 캐시 공유 (편집 후 invalidate → 뷰 자동 갱신)
// [사이드 이팩트] fetchWithEnvelope 4xx → ApiError throw → useQuery error 분기 → ErrorState
// [수정 시 고려사항] 부분 응답(권한 거부)은 BE에서 404로 통일됨 (folio-crud Q-2)

import { useQuery } from '@tanstack/react-query';
import type { Folio } from '@gangwoncanvas/types';

import { getFolioById } from '../api/folioClient.js';
import { queryKeys } from '../api/queryKeys.js';

export function useFolio(id: string | undefined) {
  return useQuery<Folio>({
    queryKey: id ? queryKeys.folio(id) : ['folio', 'noop'],
    queryFn: () => getFolioById(id!),
    enabled: !!id,
  });
}
